import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { BiUser, BiStar, BiLogOutCircle, BiLockAlt } from "react-icons/bi";
import { getBankData, getUserData } from "../../utils/common";
import { makeRequest } from "../../utils/makeRequest";
import * as urls from '../../utils/urlConst'
import toastNotify from "../../utils/toastNotify";
import { handleLoader } from "../../redux/layout";
import { exceptionLog } from "../../utils/common";

interface profileProps {
  profileMenuRef: undefined | any,
  isProfileMenu: boolean,
  setIsProfileMenu: React.Dispatch<React.SetStateAction<boolean>>,
  userProfile: string | undefined
}

const Profile: React.FC<profileProps> = ({ profileMenuRef, isProfileMenu, setIsProfileMenu, userProfile }) => {
  const navigate = useNavigate();
  const screenWidth = useSelector((state: any) => state.layout.currentScreenWidth);
  const dispatch = useDispatch();
  const userData = getUserData();
  const bankDtl: any = getBankData();

  const LoginOut = async () => {
    try {
      dispatch(handleLoader(true));
      const payload = {};
      const config = {};
      await makeRequest('POST', urls.logOut, payload, config).then((result) => {
        if (result.STATUS === '0') {
          toastNotify(result.MESSAGE, 'success');
          setIsProfileMenu(false);
          navigate('/');
        } else {
          toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Logout", "N");
      }
    } finally {
      dispatch(handleLoader(false));
    }
  };

  return (
    <div>
      {isProfileMenu && <div className={`${screenWidth <= 875 && "bg-mobile"}`}></div>}

      <div className={`profile-menu-section overflow-hidden ${screenWidth >= 875 ? "" : "Mobilenotifaction-section"}`} ref={profileMenuRef}>
        <div className="profile-details d-flex align-items-center">
          <div className="admin-img">
            {userData?.Photo === '' && userProfile === null || userProfile === "" ? (
              <img src='/imgaes/profile.png' alt={userData.FirstName} className='ProfileMenu-img rounded-circle' style={{ aspectRatio: "2/2" }} />
            ) : <img src={userProfile !== null || userProfile !== "" ? userProfile : userData.Photo} alt={userData.FirstName} className='ProfileMenu-img rounded-circle' style={{ aspectRatio: "2/2" }} />}
          </div>
          <div className="adminDetails ms-3">
            <div className="userName text-base">{userData.FirstName}</div>
            <div className="text-sm text-slate-500">+91 {userData.MobileNo}</div>
          </div>
        </div>

        <div>
          <div
            className="py-2 profile-Menu"
            onClick={() => { navigate("/profile"); setIsProfileMenu(false) }}
          >
            <div className="px-3 d-flex align-items-center ">
              <BiUser />
              <div className="ms-2">Profile</div>
            </div>
          </div>
          {bankDtl.ClientLoginType === "Y" &&
            <div
              className="py-2 profile-Menu"
              onClick={() => { navigate("/changepwd"); setIsProfileMenu(false) }}
            >
              <div className="px-3 d-flex align-items-center ">
                <BiLockAlt />
                <div className="ms-2">Change Password</div>
              </div>
            </div>
          }

          <div
            className="py-2 profile-Menu"
            onClick={() => { navigate("/feedback"); setIsProfileMenu(false) }}
          >
            <div className="px-3 d-flex align-items-center ">
              <BiStar />
              <div className="ms-2">Feedback</div>
            </div>
          </div>

          <div
            className="py-2 logOut-menu"
            onClick={() => { LoginOut(); setIsProfileMenu(false) }}
          >
            <div className="px-3 d-flex align-items-center">
              <BiLogOutCircle />
              <div className="ms-2">Log Out</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
